import React, { lazy } from 'react';
export function HeroSupportImage() {
  return <section className="bg-gradient-to-b from-[#4A3525] to-warm-mid py-14 md:py-20 px-4" data-id="element-162">
      <div className="max-w-3xl mx-auto text-center" data-id="element-163">
        {/* Text above image */}
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm mb-6" data-id="element-164">
          Made for real dog owners — not photographers
        </p>

        {/* Lifestyle image */}
        <div className="mb-6 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-165">
          <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=700&h=467&fit=crop&crop=faces&q=80" alt="Dog owner kneeling outdoors taking a photo of their happy dog with a smartphone during golden hour" className="w-full h-auto object-cover" loading="lazy" decoding="async" width={700} height={467} data-id="element-166" />
        </div>

        {/* Text below image */}
        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-167">
          You do not need a fancy camera or years of photography experience. You
          just need your phone, your dog, and{' '}
          <span className="font-semibold text-warm-hero" data-id="element-168">
            a simple system that works.
          </span>
        </p>
      </div>
    </section>;
}